import { createContext, useEffect, useState } from "react";
import { API, ENV } from "src/constant";
import { get } from "src/utils/http";

export const SettingContext = createContext("");

export const SettingContextProvider = (props) => {
    const chatbotId = props.chatbotId;
    const [settings, setSettings] = useState({
        'greeting': '',
        'header': '',
        //'relevantDocs': [],
        'subMenu': [],
        'ticketSupport': '',
    });

    useEffect(() => {
        const fetchSetting = async () => {
            get(API.GET.SETTING, { chatbotId: chatbotId}).then(
                result => {
                    const settings = result.data;
                    if (settings.relevantDocs && settings.relevantDocs.length > 0) {
                        settings.showWelcomeMsg = true;
                    }

                    setSettings(settings);
                    window.parent.postMessage("zaiChatbotReady", "*");
                },
                error => {
                    console.log(error);
                }
            );
        }
        if (chatbotId) fetchSetting();
    }, []);

    return (
        <SettingContext.Provider
            value={{
                settings,
                chatbotId
            }}
        >
            {props.children}
        </SettingContext.Provider>
    );
};